<template>
<div>
  <div class="course-form">
    <div class="dash-inner-box mb-20">
      <form class="" id="addCourse">
        <div class="dashboard-heading">
          <h1>Add New Course</h1>
        </div>
        <div class="row p10-20">
          <div class="col-md-4 mb1">
            <select id="courseStream" placeholder="Course Stream" name="stream_id" data-type="isRequired"
                    @blur="$parent.validateFiled($event)" class="formTextFields saveField">
              <option value="">Select Stream</option>
              <option v-for="s in $parent.streams" v-bind:value="s.course_enc_id">{{ s.stream }}</option>
            </select>
            <p class="errorMsg"></p>
          </div>
          <div class="col-md-4 mb1">
            <input type="text" id="courseName" placeholder="Course Name" data-type="isRequired"
                   name="course_name" @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
            <p class="errorMsg"></p>
          </div>
          <div class="col-md-4 mb1">
            <input type="text" id="courseFee" placeholder="Fees" data-type="number" data-id="reqAlso"
                   name="fees" @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
            <p class="errorMsg"></p>
          </div>
          <div class="col-md-4 mb1">
            <input type="text" id="courseDuration" placeholder="Duration" data-type="isRequired"
                   name="duration" @blur="$parent.validateFiled($event)" class="formTextFields saveField"/>
            <p class="errorMsg"></p>
          </div>
          <div class="col-md-4 mb1">
            <select class="formTextFields saveField" name="type">
              <option value="">Duration Type</option>
              <option value="Years">Year</option>
              <option value="Semesters">Semester</option>
            </select>
            <p class="errorMsg"></p>
          </div>
          <div class="col-md-4 mb1">
            <select class="formTextFields saveField" name="scholarship_id">
              <option value="">Select Scholarship</option>
              <option v-for="sch in $parent.scholarships" v-bind:value="sch.college_scholarship_enc_id">{{ sch.title }}
              </option>
            </select>
            <p class="errorMsg"></p>
          </div>
          <div class="col-md-12 text-center">
            <button type="button" class="cpe-button" v-if="$parent.notchLoading === 'addCourse'">
              <i class="fas fa-circle-notch fa-spin fa-fw"></i>
            </button>
            <button type="button" class="cpe-button" v-else @click="saveCourse()">Add</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <table class="courseTable">
        <thead>
        <tr>
          <th class="ct-course">Course</th>
          <th class="ct-stream">Stream</th>
          <th class="ct-fee">Fees</th>
          <th class="ct-duration">Duration</th>
          <th class="ct-scholarship">Scholarship</th>
          <th class="ct-edit">Edit / Add Admission Details </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="ac in $parent.addmissionCourses">
          <td>{{ ac.course_name ? ac.course_name : '-' }}</td>
          <td class="text-center">{{ ac.stream ? ac.stream : '-'}}</td>
          <td class="text-center">{{ ac.fees ? ac.fees : '-' }}</td>
          <td class="text-center">{{ ac.course_duration ? ac.course_duration : '-' }}</td>
          <td class="text-center">{{ ac.scholarship_title ? ac.scholarship_title : '-' }}</td>
          <td class="text-center">
            <button class="editCourse" v-bind:data-id="ac.assigned_college_enc_id" @click="showAdmiBar($event)">
              <i class="fas fa-pencil-alt"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="admission-sidebar admission-sidebar-close">
    <div class="cross" @click="admiClose()"><i class="fas fa-window-close"></i></div>
    <div class="row">
      <div class="col-md-12">
        <h3>Update Admission Details</h3>
        <div class="posRel">
          <div class="admission-form" id="admiForm">
            <form id="updateCourseData">
              <div class="">
                <div class="col-md-12">
                  <label>Course Name</label>
                  <input type="text" placeholder="Course Name" name="course_name"
                         disabled v-bind:value="courseData.course_name" class="formTextFields"/>
                </div>
                <div class="col-md-12">
                  <label>Course Stream</label>
                  <input type="text" placeholder="Course Stream" name="stream"
                         disabled v-bind:value="courseData.stream" class="formTextFields"/>
                </div>
                <div class="col-md-12">
                  <label>Course Fees</label>
                  <input type="text" placeholder="Course Fees" data-type="floatNum" data-id="reqAlso"
                         name="fees" @blur="$parent.validateFiled($event)" class="formTextFields saveField"
                         v-bind:value="courseData.fees"/>
                  <p class="errorMsg"></p>
                </div>
                <div class="col-md-12">
                  <label>Scholarship</label>
                  <select class="formTextFields saveField" name="scholarship_id"
                          v-bind:value="courseData.scholarship_enc_id">
                    <option value="">Select Scholarship</option>
                    <option v-for="sch in $parent.scholarships" v-bind:value="sch.college_scholarship_enc_id">
                      {{ sch.title }}
                    </option>
                  </select>
                  <p class="errorMsg"></p>
                </div>
                <div class="col-md-12">
                  <label>Course Duration</label>
                  <input type="text" placeholder="Duration" name="duration"
                         v-bind:value="courseData.course_duration"
                         class="formTextFields saveField"/>
                </div>
                <div class="col-md-12">
                  <label>Duration Type</label>
                  <select class="formTextFields saveField" name="type" v-bind:value="courseData.type">
                    <option value="">Duration Type</option>
                    <option value="Years">Year</option>
                    <option value="Semesters">Semester</option>
                  </select>
                </div>
                <div class="col-md-12">
                  <label>Selection Process</label>
                  <textarea id="admisSelection" placeholder="Selection Process" name="selection_process"
                            v-bind:value="courseData.selection_process"
                            class="formTextFields add-s-textarea saveField"></textarea>
                </div>
                <div class="col-md-12">
                  <label>Eligibility Criteria</label>
                  <textarea id="admisEligibility" placeholder="Eligibility Criteria" name="eligibility_criteria"
                            v-bind:value="courseData.eligibility_criteria"
                            class="formTextFields add-s-textarea saveField"></textarea>
                </div>
                <div class="col-md-12">
                  <label>Registration Fee</label>
                  <input type="text" id="admiRegFee" placeholder="Registration Fee" name="reg_fee"
                         class="formTextFields saveField"/>
                </div>
                <div class="col-md-12">
                  <label>Other Details</label>
                  <textarea id="admiDetails" placeholder="Other Details" name="other_details"
                            v-bind:value="courseData.other_details"
                            class="formTextFields add-d-textarea saveField"></textarea>
                </div>
                <div class="col-md-12">
                  <button type="button" class="cpe-button" v-if="$parent.notchLoading === 'updateCourseData'">
                    <i class="fas fa-circle-notch fa-spin fa-fw"></i>
                  </button>
                  <button type="button" class="cpe-button" v-else v-bind:data-id="courseData.assigned_college_enc_id"
                          @click="updateCourseData($event)">Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
  name: "CoursesAndAdmission",
  data(){
    return{
      streams: [],
      courseData: [],
    }
  },
  mounted() {

    $('#admiForm').perfectScrollbar();
    this.getStreams();
  },
  methods:{
    saveCourse() {
      let addCourse = document.querySelector('#addCourse');
      let data = this.$parent.createDataObject(addCourse);
      let hasError = addCourse.querySelector('.hasError');
      if (hasError) {
        return false;
      }
      let self = this;
      self.$parent.notchLoading = 'addCourse';
      axios.post(`${this.$parent.url}api/v2/college-profile/save-courses-fee`, data, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              self.$parent.emptyFormFields(addCourse);
              self.$parent.notchLoading = null;
            } else {
              self.$parent.notchLoading = null;
              toastr.error('Some error occurred. Try again later', 'Oops!!');
            }
          }
      )
    },
    getStreams() {
      let t = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/get-streams`, {}, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              t.streams = response['data']['response']['streams'];
            } else {

            }
          }
      )
    },
    showAdmiBar(event) {
      let t = this;
      let admiSidebar = document.querySelector('.admission-sidebar');
      admiSidebar.classList.remove('admission-sidebar-close');
      let courseID = event.target.parentElement.getAttribute('data-id');
      let cData = t.$parent.addmissionCourses.filter(
          addmissionCourse => addmissionCourse.assigned_college_enc_id == courseID
      );
      t.courseData = cData[0];
      console.log(t.courseData);
      let PsCon = admiSidebar.querySelector('.ps-container');
      let XRail = PsCon.querySelector('.ps-scrollbar-x-rail');
      XRail.classList.add('XRail');
    },
    updateCourseData(event) {
      let updateCourseData = document.querySelector('#updateCourseData');
      let data = this.$parent.createDataObject(updateCourseData);
      let course_id = event.target.getAttribute('data-id');
      data.append('college_course_id', course_id);
      let self = this;
      self.$parent.notchLoading = 'updateCourseData';
      axios.post(`${this.$parent.url}api/v2/college-profile/edit-admission-detail`, data, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              self.$parent.getAdmissionCourses()
              self.$parent.notchLoading = null;
            }else{
              self.$parent.notchLoading = null;
            }
          }
      )
    },
    admiClose() {
      let admiSidebar = document.querySelector('.admission-sidebar');
      admiSidebar.classList.add('admission-sidebar-close');
    },
  }

}
</script>

<style scoped>

</style>